import { IWorkspacePermissionAccess, IWorkspaceResourceFolder, WorkspaceResourceType } from "common/interfaces";
import WorkspaceController, { getWorkspaceResources } from "js/controllers/WorkspaceController";
import getLogger, { LogGroup } from "js/core/logger";

const logger = getLogger(LogGroup.TEAMS);

const DEFAULT_PERMISSIONS: Omit<IWorkspacePermissionAccess, "owner"> = {
    read: { object: true, permissions: true },
    write: { object: false, permissions: false },
};

export async function moveSubfolderContentsToParentFolder(
    folder: IWorkspaceResourceFolder,
    resourceTypes: WorkspaceResourceType[],
    permissions: Omit<IWorkspacePermissionAccess, "owner"> = DEFAULT_PERMISSIONS
) {
    const parentFolderId = folder.parentFolderId;
    if (!parentFolderId || resourceTypes.length === 0) {
        return;
    }

    const resources = await getWorkspaceResources({
        workspaceId: WorkspaceController.workspaceId,
        resourceTypes,
        resourceFilters: [{ field: "folderIds", operator: "eq", value: folder.id }],
    });

    if (resources.length === 0) {
        return;
    }

    try {
        await WorkspaceController.updateWorkspaceResourceFolderResources({
            folderId: parentFolderId,
            update: {
                add: resources.map(resource => ({
                    resourceId: resource.resourceId,
                    resourceType: resource.resourceType,
                    permissions
                })),
            },
        });
    } catch (err) {
        logger.error(err, "[moveSubfolderContentsToParentFolder] failed", {
            folderId: folder.id,
            parentFolderId,
        });
        throw err;
    }
}
